import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#1976D2', // 1976D2
        secondary: '#ededed', // 424242
        accent: '#82B1FF', // 82B1FF
        error: '#FF5252', // FF5252
        info: '#2196F3', // 2196F3
        success: '#6cbf71', // 4CAF50
        warning: '#ffa600', // ffa600
        back: '#bbbbbb',
      },
      dark: {
        primary: '#6caef0', // 1976D2
        secondary: '#424242', // 424242
        accent: '#82B1FF', // 82B1FF
        error: '#ff8a8a', // FF5252
        info: '#2196F3', // 2196F3
        success: '#3d8b41', // 4CAF50
        warning: '#ffa600', // ffa600
        back: '#222222',
      },
    },
    dark: true,
    options: { customProperties: true },
  },
  icons: {
    iconfont: 'mdi', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
});
